import { render, staticRenderFns } from "./AuthenticationEditor.vue?vue&type=template&id=3b12b8ce&scoped=true"
import script from "./AuthenticationEditor.vue?vue&type=script&lang=js"
export * from "./AuthenticationEditor.vue?vue&type=script&lang=js"
import style0 from "./AuthenticationEditor.vue?vue&type=style&index=0&id=3b12b8ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b12b8ce",
  null
  
)

export default component.exports